import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import JsonCSV from 'vue-json-csv'

Vue.use(Vuex)
import Buefy from 'buefy'


Vue.component('downloadCsv', JsonCSV)
//For use in batch imports
import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)

//Amplify
import Amplify, { Auth } from 'aws-amplify';
import '@aws-amplify/ui-vue';

import aws_exports from './aws-exports';

Amplify.configure(aws_exports);
Auth.configure(aws_exports);
Vue.config.productionTip = false
Vue.use(Buefy)


new Vue({
  router,
  store,
  linkActiveClass: 'is-active',
  render: h => h(App)
}).$mount('#app')
